import { render, staticRenderFns } from "./EmailTemplateParams.vue?vue&type=template&id=243eb6da&"
import script from "./EmailTemplateParams.js?vue&type=script&lang=js&"
export * from "./EmailTemplateParams.js?vue&type=script&lang=js&"
import style0 from "./EmailTemplateParams.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports